import buildConfig, { BaseAppConfig } from "./base";

const baseApi = "https://effno-server.onrender.com/api";
const env = buildConfig(baseApi);

export default {
  ...env,
  environment: "production",
  redirect: "https://effno-client.onrender.com/signup",
  clientUrl: "https://effno-client.onrender.com",
  hostname: "effno-client.onrender.com",
  allowNewWorkspace: true,
} as BaseAppConfig;
